var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8585_10596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6746 14.3008L0.113525 27.461C0.254585 27.9609 0.508074 28.4219 0.854615 28.8089C1.20116 29.1958 1.63157 29.4983 2.11297 29.6934C2.59436 29.8885 3.11398 29.9709 3.63211 29.9344C4.15024 29.8979 4.65316 29.7434 5.10243 29.4827L19.236 21.4331L12.6746 14.3008Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.376 12.0633L19.2642 8.5625L12.3845 14.5996L19.2922 21.4137L25.3575 17.9505C25.8948 17.6691 26.3448 17.2461 26.6588 16.7272C26.9729 16.2083 27.1389 15.6133 27.1389 15.0068C27.1389 14.4003 26.9729 13.8054 26.6588 13.2865C26.3448 12.7676 25.8948 12.3445 25.3575 12.0632H25.3762L25.376 12.0633Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.113379 2.48828C0.0374543 2.76897 -0.000340869 3.0586 0.00101161 3.34938V26.5996C0.0017988 26.8903 0.0395577 27.1796 0.113379 27.4608L13.1051 14.6375L0.113379 2.48828Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7682 14.976L19.2641 8.56442L5.14928 0.477356C4.61822 0.166339 4.01422 0.00163067 3.39879 6.50145e-06C1.87155 -0.0029617 0.528861 1.01068 0.113525 2.48047L12.7682 14.976Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8585_10596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.14,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.6528b398d03df0df8ef41303537ef7d5.svg";
export { ForwardRef as ReactComponent };